function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCloseIcon = function SvgCloseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.205 12.18a.73.73 0 0 0 .32.18.702.702 0 0 0 .672-.18l5-5 5 5a.702.702 0 0 0 .672.18.6.6 0 0 0 .32-.18.621.621 0 0 0 .172-.313.702.702 0 0 0 0-.36.62.62 0 0 0-.171-.312l-5-5.008 5-5a.702.702 0 0 0 0-.984.64.64 0 0 0-.32-.18.7.7 0 0 0-.36 0 .597.597 0 0 0-.313.18l-5 5-5-5a.6.6 0 0 0-.32-.18.7.7 0 0 0-.36 0 .597.597 0 0 0-.312.18.676.676 0 0 0-.18.313.836.836 0 0 0 0 .359c.032.12.092.224.18.313l5 5-5 5.007a.676.676 0 0 0-.18.313.763.763 0 0 0-.007.36c.031.119.094.223.187.312Z",
    fill: props.color || '#212240'
  }));
};

export default SvgCloseIcon;